import { React,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SettingsReducer } from "../../../redux/Setting"
import { useEffect } from "react";
import ApperanceUi from '../UI/ApperanceUi'
const SettingActions = SettingsReducer.actions;



const getArabicSliderValue = (fontSizeRem) => {
  const size = parseFloat(fontSizeRem);
  if (size <= 1.625) return 1;      // Small
  if (size <= 2.375) return 2;      // Medium
  if (size <= 3.125) return 3;      // Large
  return 4;                         // Huge
};

const getTranslationSliderValue = (fontSizeRem) => {
  const size = parseFloat(fontSizeRem);
  if (size <= 1.25) return 1;       // Small
  if (size <= 2.0) return 2;        // Medium
  if (size <= 2.75) return 3;       // Large
  return 4;                         // Huge
};

function Apperance(props) {
  const dispatch = useDispatch()
  const selectedScript = useSelector((state) => state.settings.script);
  const arabicFontSize = useSelector((state) => state.settings.arabicFontSize);
  const arabicFontText = useSelector((state) => state.settings.arabicFontText);
  const translationFontSize = useSelector((state) => state.settings.translationFontSize);
  const translationFontText = useSelector((state) => state.settings.translationFontText);
  const selectedTheme = useSelector((state) => state.settings.userTheme);
  
  const [arabicFontValue, setArabicFontValue] = useState(() => getArabicSliderValue(arabicFontSize));
  const [translationFontValue, setTranslationFontValue] = useState(() => getTranslationSliderValue(translationFontSize));

  useEffect(() => {
    setArabicFontValue(getArabicSliderValue(arabicFontSize));
  }, [arabicFontSize]);

  useEffect(() => {
    setTranslationFontValue(getTranslationSliderValue(translationFontSize));
  }, [translationFontSize]);

  const min = 1; 
  const max = 4; 
  const percentage = ((arabicFontValue - min) / (max - min)) * 100;
  const percentageTranslation = ((translationFontValue - min) / (max - min)) * 100;

  const trackStyleArabic = {
    background: `linear-gradient(90deg, #006B9E ${percentage}%, #D9D9D9 ${percentage}%)`,
  };
  const trackStyleTranslation = {
    background: `linear-gradient(90deg, #006B9E ${percentageTranslation}%, #D9D9D9 ${percentageTranslation}%)`,
  };
  
  const handleThemeChange = (theme) => {
    dispatch(SettingActions.updateSettings({ userTheme: theme }));
  }
  const handleChangeArabic = (e) => {
    const newValue = parseInt(e.target.value, 10);
    setArabicFontValue(newValue);
    if (newValue === 1) {
      dispatch(SettingActions.updateSettings({ arabicFontText: "Small", arabicFontSize: 1.62500 }));
    } else if (newValue === 2) {
      dispatch(SettingActions.updateSettings({ arabicFontText: "Medium", arabicFontSize: 2.37500 }));
    } else if (newValue === 3) {
      dispatch(SettingActions.updateSettings({ arabicFontText: "Large", arabicFontSize: 3.12500 }));
    } else if (newValue === 4) {
      dispatch(SettingActions.updateSettings({ arabicFontText: "Huge", arabicFontSize: 4 }));
    }
  };

  const handleChangeTranslation = (e) => {
    const newValue = parseInt(e.target.value, 10);
    setTranslationFontValue(newValue);
    if (newValue === 1) {
      dispatch(SettingActions.updateSettings({ translationFontText: "Small", translationFontSize: 1.25 }));
    } else if (newValue === 2) {
      dispatch(SettingActions.updateSettings({ translationFontText: "Medium", translationFontSize: 2 }));
    } else if (newValue === 3) {
      dispatch(SettingActions.updateSettings({ translationFontText: "Large", translationFontSize: 2.75 }));
    } else if (newValue === 4) {
      dispatch(SettingActions.updateSettings({ translationFontText: "Huge", translationFontSize: 3.625 }));
    }
  };


  useEffect(() => {
  }, [selectedScript]);

  const handleScriptChange = (script) => {
    dispatch(SettingActions.updateSettings({ script: script }));
  };
  const onOverlayClick = () => {
    props.handleClickAway_CloseMenu()
  }

  return (
    <ApperanceUi t={props.t} closeSettings={props.closeSettings} selectedMenu={props.selectedMenu} 
    handleScriptChange={handleScriptChange}
    selectedScript={selectedScript}
     onOverlayClick={onOverlayClick}
     arabicFontValue={arabicFontValue}
     arabicFontSize={arabicFontSize}
     arabicFontText={arabicFontText}
     translationFontValue={translationFontValue}
     translationFontSize={translationFontSize}
     translationFontText={translationFontText}
     handleChangeArabic={handleChangeArabic}
     handleChangeTranslation={handleChangeTranslation}
     trackStyleArabic={trackStyleArabic}
     trackStyleTranslation={trackStyleTranslation}
     handleThemeChange={handleThemeChange}
     selectedTheme={selectedTheme}
    />
  )
}

export default Apperance
